export default {"src":"/_next/static/media/logo_unity.f5d4f938.svg","height":56,"width":134,"blurWidth":0,"blurHeight":0};